/** Motifs de rejet par question éliminatoire */
const rejectionReasons = {
  usage_professionnel:
    "Vous n'utilisez pas de véhicule à des fins professionnelles (trajets domicile-travail inclus).",
  vehicule_conditions:
    "Votre véhicule ne respecte pas l'ensemble des conditions requises (assurance, type de véhicule, motorisation, etc.).",
  grand_rouleur:
    "Vous n'effectuez pas plus de 15 km par trajet domicile-travail, ni plus de 8 000 km par an à titre professionnel.",
  domicile_fiscal:
    "Vous n'êtes pas établi(e) et domicilié(e) fiscalement en France (métropole ou DOM éligibles) au titre de l'année 2024.",
  age: "Vous n'aviez pas au moins 16 ans au 31 décembre 2024.",
  revenu_activite:
    "Vous n'avez pas déclaré de revenu d'activité au titre des revenus 2024.",
  types_revenus:
    "Aucun type de revenu d'activité éligible n'a été sélectionné (salaires, BIC, BNC ou BA).",
  ifi: "Vous êtes redevable de l'impôt sur la fortune immobilière (IFI) au titre de 2024.",
  ressources:
    "Votre revenu fiscal de référence par part dépasse le plafond de 16 880 €.",
};

export default rejectionReasons;
